
import TextInput from '../input'
import { api, getBaseUrl } from '~/config/api'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import { states } from '~/helpers/states'

export default {
  name: 'RegistrationStepOne',
  mixins: [ui],
  components: {
    TextInput
  },
  props: {
    user: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      licenseNumber: this.user.licenseNumber,
      licenseNumberValid: !!this.user.licenseNumber,
      state: this.user.state,
      states,
      externalError: ''
    }
  },
  computed: {
    valid() {
      return this.licenseNumberValid && !!this.state
    }
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit('validation', v)
      },
      immediate: true
    }
  },
  methods: {
    async nextBtnClickHandler() {
      try {
        this.showFSLoader()

        const res = await this.$axios.post(`${getBaseUrl()}/api/auth/${api.CHECK_LICENSE}`, {
          licenseNumber: this.licenseNumber,
          state: this.state
        })

        return {
          ...res.data,
          licenseNumber: this.licenseNumber,
          state: this.state
        }
      } catch (e) {
        this.externalError = e.response?.data?.error ?? 'Something went wrong'
        return null
      } finally {
        this.hideFSLoader()
      }
    }
  }
}
